module.exports = __webpack_public_path__ + "img/sails.075ae0ee.svg";